import { ISetPriorityParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetExtractTasksPriorityRequest extends Request<ISetPriorityParams, IResult> {
  constructor(ids: string[], priority: number) {
    super('setExtractTasksPriority', {
      ids: ids,
      priority: priority
    });
  }
}
